import React, { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Listbox, Transition } from '@headlessui/react';
import Loader from '../components/Loader';
import { fetchTicketById } from '../api/zoho';
import { fetchCity, fetchSuburb } from '../api/dropdown';
import { updateTicketById } from '../api/zoho';
import { Toaster, ToastIcon, toast, resolveValue } from 'react-hot-toast';
import { getDatePlusHours } from '../utils/date';

const people = ['منشأ', 'تحت العمل', 'منتهي', 'ملغي'];
const TailwindToaster = () => {
  return (
    <Toaster>
      {(t) => (
        <Transition
          appear
          show={t.visible}
          className='transform p-4 flex bg-white rounded shadow-lg'
          enter='transition-all duration-150'
          enterFrom='opacity-0 scale-50'
          enterTo='opacity-100 scale-100'
          leave='transition-all duration-150'
          leaveFrom='opacity-100 scale-100'
          leaveTo='opacity-0 scale-75'
        >
          <ToastIcon toast={t} />
          <p className='px-2'>{resolveValue(t.message)}</p>
        </Transition>
      )}
    </Toaster>
  );
};
let citys = [
  { id: 1, name: 'طرابلس' },
  { id: 2, name: 'مصراتة' },
  { id: 3, name: 'بنغازي' },
];
let suburbs = [
  { id: 1, name: '11يونيو' },
  { id: 2, name: 'الحي الاسلامي' },
  { id: 3, name: 'السبعة' },
];

const TicketScreen = () => {
  let { id } = useParams();
  let navigate = useNavigate();
  const [loadding, setLoadding] = useState(false);
  const [error, setError] = useState('');
  const [ticket, setTicket] = useState();
  const [selectedCity, setSelectedCity] = useState(citys[0].name);
  const [selectedSuburb, setSelectedSuburb] = useState(suburbs[0].name);
  const [selectedPerson, setSelectedPerson] = useState(people[0]);

  const schema = yup.object().shape({
    accountCode: yup.string().required(),
    accountType: yup.string(),
    requestType: yup.string(),
    clientName: yup.string(),
    phone: yup.string().required(),
    city: yup.string(),
    suburb: yup.string(),
    notes: yup.string(),
    status: yup.string(),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    setLoadding(true);
    setError('');
    try {
      async function fetchData() {
        const cityRes = await fetchCity();
        const suburbRes = await fetchSuburb();
        if (cityRes.data.success) {
          citys = cityRes.data.data;
        }
        if (suburbRes.data.success) {
          suburbs = suburbRes.data.data;
        }
      }
      fetchData();

      fetchTicketById(id)
        .then((data) => {
          if (data.success === false) {
            if (data.error.response.status == 404) {
              // toast.error('لا يوجد بيانات لعرضها');
              // navigate(`/IncomingCallScreen/${phoneNumber}`);
            }
          }
          if (data.success === true) {
            if (data?.data) {
              // toast.success('تم تحميل البيانات بنجاح');
              setTicket(data.data);
              console.log(data);
              setValue('accountCode', data?.data?.contactId, {
                shouldValidate: true,
              });
              setValue('phone', data?.data?.phone, {
                shouldValidate: true,
              });
              setValue('accountType', data?.data?.cf?.cf_nw_alhsab || 'SRV', {
                shouldValidate: true,
              });
              // setValue('accountType', data?.data?.cf?.cf_nw_alhsab || 'SRV', {
              //   shouldValidate: true,
              // });
              setValue('notes', data?.data?.description || '', {
                shouldValidate: true,
              });
              setSelectedCity(data?.data?.cf?.cf_almdynt);
              setSelectedSuburb(data?.data?.cf?.cf_aldahyt);
              setSelectedPerson(data?.data?.status);
              setValue(
                'clientName',
                data?.data?.contact?.firstName +
                  ' ' +
                  data?.data?.contact?.lastName,
                {
                  shouldValidate: true,
                }
              );
            } else {
              // toast.error('لا يوجد بيانات لعرضها');
            }
          } else {
            // toast.error('لا يوجد بيانات لعرضها');
          }
        })
        .catch((err) => {
          // setError(err.message);

          // toast.error('حدث خطأ ما');
          console.log(err, 'err');
        })
        .finally(() => {
          setLoadding(false);
        });
    } catch (error) {
      setError(error.message);
    }
  }, []);

  useEffect(() => {
    setValue('city', selectedCity, {
      shouldValidate: true,
    });
    setValue('suburb', selectedSuburb, {
      shouldValidate: true,
    });
    setValue('status', selectedPerson, {
      shouldValidate: true,
    });
  }, [selectedCity, selectedSuburb, selectedPerson]);

  const signupHandler = async () => {
    navigate(`/CalLlogsScreen/${ticket.phone}`);
  };

  const onSubmit = (data, e) => {
    e.preventDefault();
    console.log(data);
    updateTicketById(data, id)
      .then((res) => {
        toast.success('تم التعديل');
        setTimeout(() => {}, 2000);
        signupHandler();
      })
      .catch((err) => {
        toast.error('حدث خطا');
        setTimeout(() => {}, 2000);
      });
  };

  return (
    <>
      {loadding && !ticket ? (
        <div
          className='bg-background-100 min-h-screen h-full flex  w-full align-middle mx-auto justify-center items-center'
          dir='rtl'
        >
          <Loader />
        </div>
      ) : (
        <div
          className='bg-background-100 min-h-screen h-full  w-full flex flex-col container px-64 py-20'
          dir='rtl'
        >
          <div className='mx-auto '>
            <p className='text-title-100 text-xl font-bold'>
              المكالمة {ticket?.ticketNumber}{' '}
            </p>
          </div>
          <div className='flex flex-row justify-between'>
            <div className='pt-14'>
              <p className='text-title-100 text-xl '>
                نوع المكالمة :{ticket?.cf?.cf_tsnyf_almkalmt_1}
              </p>
              <p className='text-title-100 text-xl  pt-10'>
                التاريخ :{' '}
                {getDatePlusHours(ticket?.createdTime.split('.')[0], 2)}
              </p>
            </div>
            <div className='flex  pt-12'>
              <div className='w-full  '>
                <Listbox
                  as='div'
                  className='space-y-1'
                  value={selectedPerson}
                  onChange={setSelectedPerson}
                >
                  {({ open }) => (
                    <>
                      <Listbox.Label className='block  leading-5 text-title-100 text-xl pb-4'>
                        حالة النموذج
                      </Listbox.Label>
                      <div className='relative'>
                        <span className='inline-block w-full rounded-md shadow-sm'>
                          <Listbox.Button className='cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5'>
                            <span className='block truncate'>
                              {selectedPerson}
                            </span>
                            <span className='absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none'>
                              <svg
                                className='h-5 w-5 text-gray-400'
                                viewBox='0 0 20 20'
                                fill='none'
                                stroke='currentColor'
                              >
                                <path
                                  d='M7 7l3-3 3 3m0 6l-3 3-3-3'
                                  strokeWidth='1.5'
                                  strokeLinecap='round'
                                  strokeLinejoin='round'
                                />
                              </svg>
                            </span>
                          </Listbox.Button>
                        </span>

                        {ticket?.cf?.cf_tsnyf_almkalmt_1 !== 'طلب خدمة' ? (
                          <Transition
                            show={open}
                            leave='transition ease-in duration-100'
                            leaveFrom='opacity-100'
                            leaveTo='opacity-0'
                            className='absolute mt-1 w-full rounded-md bg-white shadow-lg'
                          >
                            <Listbox.Options
                              static
                              className='max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5'
                            >
                              {people.map((person) => (
                                <Listbox.Option key={person} value={person}>
                                  {({ selected, active }) => (
                                    <div
                                      className={`${
                                        active
                                          ? 'text-white bg-blue-600'
                                          : 'text-gray-900'
                                      } cursor-default select-none relative py-2 pl-8 pr-4`}
                                    >
                                      <span
                                        className={`${
                                          selected
                                            ? 'font-semibold'
                                            : 'font-normal'
                                        } block truncate`}
                                      >
                                        {person}
                                      </span>
                                      {selected && (
                                        <span
                                          className={`${
                                            active
                                              ? 'text-white'
                                              : 'text-blue-600'
                                          } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                        >
                                          <svg
                                            className='h-5 w-5'
                                            xmlns='http://www.w3.org/2000/svg'
                                            viewBox='0 0 20 20'
                                            fill='currentColor'
                                          >
                                            <path
                                              fillRule='evenodd'
                                              d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                              clipRule='evenodd'
                                            />
                                          </svg>
                                        </span>
                                      )}
                                    </div>
                                  )}
                                </Listbox.Option>
                              ))}
                            </Listbox.Options>
                          </Transition>
                        ) : (
                          <></>
                        )}
                      </div>
                    </>
                  )}
                </Listbox>
              </div>
            </div>
          </div>
          <div className='py-12'>
            <p className='text-title-100 text-xl'>بيانات العميل</p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className='flex flex-col space-y-4'>
              <div className='grid grid-cols-2 gap-44'>
                <div>
                  <label htmlFor='' className=' text-title-100 text-md block'>
                    <span className='px-1'>رقم العميل</span>
                  </label>
                  <input
                    name='accountCode'
                    {...register('accountCode')}
                    type='accountCode'
                    // value={number}
                    readOnly={
                      ticket?.cf?.cf_tsnyf_almkalmt_1 !== 'طلب خدمة'
                        ? false
                        : true
                    }
                    className='w-full p-2 border border-gray-300 rounded mt-1'
                  />
                  <p className=' opacity-50 text-s'>
                    {errors?.accountCode?.message}
                  </p>
                </div>
                <div>
                  <label htmlFor='' className=' text-title-100 text-md block'>
                    <span className='px-1'>نوع الحساب</span>
                  </label>
                  <input
                    name='accountType'
                    {...register('accountType')}
                    type='accountType'
                    readOnly={
                      ticket?.cf?.cf_tsnyf_almkalmt_1 !== 'طلب خدمة'
                        ? false
                        : true
                    }
                    className='w-full p-2 border border-gray-300 rounded mt-1'
                  />
                  <p className=' opacity-50 text-s'>
                    {errors?.accountType?.message}
                  </p>
                </div>
              </div>
              <div className='grid grid-cols-2 gap-44'>
                <div>
                  <label htmlFor='' className=' text-title-100 text-md block'>
                    <span className='px-1'>الاسم</span>
                  </label>
                  <input
                    name='clientName'
                    {...register('clientName')}
                    type='clientName'
                    className='w-full p-2 border border-gray-300 rounded mt-1'
                    readOnly={
                      ticket?.cf?.cf_tsnyf_almkalmt_1 !== 'طلب خدمة'
                        ? false
                        : true
                    }
                  />
                  <p className=' opacity-50 text-s'>
                    {errors?.clientName?.message}
                  </p>
                </div>
                <div>
                  <label htmlFor='' className=' text-title-100 text-md block'>
                    <span className='px-1'>رقم الهاتف</span>
                  </label>
                  <input
                    name='phone'
                    {...register('phone')}
                    type='phone'
                    readOnly={
                      ticket?.cf?.cf_tsnyf_almkalmt_1 !== 'طلب خدمة'
                        ? false
                        : true
                    }
                    className='w-full p-2 border border-gray-300 rounded mt-1'
                  />
                  <p className=' opacity-50 text-s'>{errors?.phone?.message}</p>
                </div>
              </div>
              <div className='grid grid-cols-2 gap-44'>
                <div className='flex '>
                  <div className='w-full  '>
                    <Listbox
                      as='div'
                      className='space-y-1'
                      value={selectedCity}
                      onChange={setSelectedCity}
                    >
                      {({ open }) => (
                        <>
                          <Listbox.Label className='block  leading-5 text-title-100 text-md pb-4'>
                            المدينة
                          </Listbox.Label>
                          <div className='relative'>
                            <span className='inline-block w-full rounded-md shadow-sm'>
                              <Listbox.Button className='cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5'>
                                <span className='block truncate'>
                                  {selectedCity}
                                </span>
                                <span className='absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none'>
                                  <svg
                                    className='h-5 w-5 text-gray-400'
                                    viewBox='0 0 20 20'
                                    fill='none'
                                    stroke='currentColor'
                                  >
                                    <path
                                      d='M7 7l3-3 3 3m0 6l-3 3-3-3'
                                      strokeWidth='1.5'
                                      strokeLinecap='round'
                                      strokeLinejoin='round'
                                    />
                                  </svg>
                                </span>
                              </Listbox.Button>
                            </span>

                            {ticket?.cf?.cf_tsnyf_almkalmt_1 !== 'طلب خدمة' ? (
                              <Transition
                                show={open}
                                leave='transition ease-in duration-100'
                                leaveFrom='opacity-100'
                                leaveTo='opacity-0'
                                className='absolute mt-1 w-full rounded-md bg-white shadow-lg'
                              >
                                <Listbox.Options
                                  static
                                  className='max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5'
                                >
                                  {citys.map((person) => (
                                    <Listbox.Option
                                      key={person.name}
                                      value={person.name}
                                    >
                                      {({ selected, active }) => (
                                        <div
                                          className={`${
                                            active
                                              ? 'text-white bg-blue-600'
                                              : 'text-gray-900'
                                          } cursor-default select-none relative py-2 pl-8 pr-4`}
                                        >
                                          <span
                                            className={`${
                                              selected
                                                ? 'font-semibold'
                                                : 'font-normal'
                                            } block truncate`}
                                          >
                                            {person.name}
                                          </span>
                                          {selected && (
                                            <span
                                              className={`${
                                                active
                                                  ? 'text-white'
                                                  : 'text-blue-600'
                                              } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                            >
                                              <svg
                                                className='h-5 w-5'
                                                xmlns='http://www.w3.org/2000/svg'
                                                viewBox='0 0 20 20'
                                                fill='currentColor'
                                              >
                                                <path
                                                  fillRule='evenodd'
                                                  d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                                  clipRule='evenodd'
                                                />
                                              </svg>
                                            </span>
                                          )}
                                        </div>
                                      )}
                                    </Listbox.Option>
                                  ))}
                                </Listbox.Options>
                              </Transition>
                            ) : (
                              <></>
                            )}
                          </div>
                        </>
                      )}
                    </Listbox>
                  </div>
                </div>{' '}
                <div className='flex  '>
                  <div className='w-full  '>
                    <Listbox
                      as='div'
                      className='space-y-1'
                      value={selectedSuburb}
                      onChange={setSelectedSuburb}
                    >
                      {({ open }) => (
                        <>
                          <Listbox.Label className='block  leading-5 text-title-100 text-md pb-4'>
                            الضاحية
                          </Listbox.Label>
                          <div className='relative'>
                            <span className='inline-block w-full rounded-md shadow-sm'>
                              <Listbox.Button className='cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5'>
                                <span className='block truncate'>
                                  {selectedSuburb}
                                </span>
                                <span className='absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none'>
                                  <svg
                                    className='h-5 w-5 text-gray-400'
                                    viewBox='0 0 20 20'
                                    fill='none'
                                    stroke='currentColor'
                                  >
                                    <path
                                      d='M7 7l3-3 3 3m0 6l-3 3-3-3'
                                      strokeWidth='1.5'
                                      strokeLinecap='round'
                                      strokeLinejoin='round'
                                    />
                                  </svg>
                                </span>
                              </Listbox.Button>
                            </span>
                            {ticket?.cf?.cf_tsnyf_almkalmt_1 !== 'طلب خدمة' ? (
                              <Transition
                                show={open}
                                leave='transition ease-in duration-100'
                                leaveFrom='opacity-100'
                                leaveTo='opacity-0'
                                className='absolute mt-1 w-full rounded-md bg-white shadow-lg'
                              >
                                <Listbox.Options
                                  static
                                  className='max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5'
                                >
                                  {suburbs.map((person) => (
                                    <Listbox.Option
                                      key={person.name}
                                      value={person.name}
                                    >
                                      {({ selected, active }) => (
                                        <div
                                          className={`${
                                            active
                                              ? 'text-white bg-blue-600'
                                              : 'text-gray-900'
                                          } cursor-default select-none relative py-2 pl-8 pr-4`}
                                        >
                                          <span
                                            className={`${
                                              selected
                                                ? 'font-semibold'
                                                : 'font-normal'
                                            } block truncate`}
                                          >
                                            {person.name}
                                          </span>
                                          {selected && (
                                            <span
                                              className={`${
                                                active
                                                  ? 'text-white'
                                                  : 'text-blue-600'
                                              } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                            >
                                              <svg
                                                className='h-5 w-5'
                                                xmlns='http://www.w3.org/2000/svg'
                                                viewBox='0 0 20 20'
                                                fill='currentColor'
                                              >
                                                <path
                                                  fillRule='evenodd'
                                                  d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                                  clipRule='evenodd'
                                                />
                                              </svg>
                                            </span>
                                          )}
                                        </div>
                                      )}
                                    </Listbox.Option>
                                  ))}
                                </Listbox.Options>
                              </Transition>
                            ) : (
                              <></>
                            )}
                          </div>
                        </>
                      )}
                    </Listbox>
                  </div>
                </div>
              </div>
              <div className='grid grid-cols-2 gap-44'>
                <div className='col-span-2'>
                  <label
                    htmlFor=''
                    className=' text-title-100 text-md block pb-4'
                  >
                    <span className='px-1 '>ملاحظات</span>
                  </label>
                  <textarea
                    rows='4'
                    className='block p-2.5 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 '
                    placeholder=''
                    name='notes'
                    {...register('notes')}
                  ></textarea>
                  <p className=' opacity-50 text-s'>{errors?.notes?.message}</p>
                </div>
              </div>
            </div>
            <div className='pt-12 justify-center flex'>
              {
                <button
                  type='submit'
                  className='text-white bg-button-100    font-medium  text-sm px-10 py-2.5 mr-2 mb-2   rounded '
                  // onClick={() => signupHandler(ticket)}
                >
                  تعديل
                </button>
              }
              <button
                type='button'
                className='bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white  border border-blue-500 hover:border-transparent rounded text-sm px-6 py-2.5 mr-2 mb-2    '
                onClick={() => signupHandler(ticket)}
              >
                الإستمرار
              </button>
            </div>
          </form>
          <TailwindToaster />
        </div>
      )}
    </>
  );
};

export default TicketScreen;
